/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 *
 * @export
 * @enum {string}
 */
export enum EdiOutboundTrackingState {
  Pending = "pending",
  Sent = "sent",
  Failed = "failed",
  Superseded = "superseded",
}

export function instanceOfEdiOutboundTrackingState(value: any): boolean {
  for (const key in EdiOutboundTrackingState) {
    if (Object.prototype.hasOwnProperty.call(EdiOutboundTrackingState, key)) {
      if (
        EdiOutboundTrackingState[
          key as keyof typeof EdiOutboundTrackingState
        ] === value
      ) {
        return true;
      }
    }
  }
  return false;
}

export function EdiOutboundTrackingStateFromJSON(
  json: any,
): EdiOutboundTrackingState {
  return EdiOutboundTrackingStateFromJSONTyped(json, false);
}

export function EdiOutboundTrackingStateFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): EdiOutboundTrackingState {
  return json as EdiOutboundTrackingState;
}

export function EdiOutboundTrackingStateToJSON(
  value?: EdiOutboundTrackingState | null,
): any {
  return value as any;
}

export function EdiOutboundTrackingStateToJSONTyped(
  value: any,
  ignoreDiscriminator: boolean,
): EdiOutboundTrackingState {
  return value as EdiOutboundTrackingState;
}
